module.exports = __webpack_public_path__ + "static/media/afford.ca823502.png";